import type { SVGProps } from 'react';

const SvgBellCrossed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11.49 6.73c.23-.02.46-.03.69-.02C15.39 6.81 18 9.63 18 13c0 .55.45 1 1 1s1-.45 1-1c0-4.01-2.84-7.43-6.55-8.15.03-.11.05-.23.05-.35 0-.83-.67-1.5-1.5-1.5a1.498 1.498 0 0 0-1.37 2.11c-.15.19-.24.44-.22.7.04.55.52.96 1.08.91zm9.22 12.56-16-16A.996.996 0 1 0 3.3 4.7l2.71 2.71A8 8 0 0 0 4 12.7v3.29c0 1.65 1.35 3 3 3h3c0 1.1.9 2 2 2s2-.9 2-2h3c.18 0 .36-.02.53-.06l1.76 1.76c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM7 17c-.55 0-1-.45-1-1v-3.29c0-1.43.52-2.79 1.42-3.87L15.58 17z"
    />
  </svg>
);
export default SvgBellCrossed;
